import { Util } from "../../../util/util";
export class AfterTaxProportionalDistributor {
    distribute(params) {
        const { discountItems, totalDiscountedItemsPrice, computedDiscountToAllocate } = params;
        let tSplit = 0;
        for (const dItem of discountItems) {
            if (dItem.cPrice > 0) {
                const discount = Math.max(0, Util.Float2((dItem.oPrice * computedDiscountToAllocate / totalDiscountedItemsPrice) - dItem.addOn));
                dItem.afterTaxDiscount = discount;
                tSplit += discount;
            }
        }
        const last = discountItems.at(-1);
        if (last) {
            last.afterTaxDiscount = Math.max(0, last.afterTaxDiscount + (computedDiscountToAllocate - tSplit));
        }
    }
}
//# sourceMappingURL=after-tax-proportional-distributor.js.map